import { render, staticRenderFns } from "./PagamentoAssociarConsultorias.vue?vue&type=template&id=15278871"
import script from "./PagamentoAssociarConsultorias.vue?vue&type=script&lang=js"
export * from "./PagamentoAssociarConsultorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports